"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("div", {
    staticClass: "filter-container"
  }, [_c("el-select", {
    staticClass: "filter-item",
    attrs: {
      "remote-method": _vm.fetchClientList,
      filterable: "",
      clearable: "",
      "default-first-option": "",
      remote: "",
      placeholder: _vm.$t("contact.client")
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.clientId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "clientId", $$v);
      },
      expression: "listQuery.clientId"
    }
  }, _vm._l(_vm.clientList, function (client) {
    return _c("el-option", {
      key: client.id,
      attrs: {
        value: client.id,
        label: client.name
      }
    });
  }), 1), _c("el-input", {
    staticClass: "filter-item",
    style: {
      width: Math.max(160, (_vm.listQuery.firstName ? _vm.listQuery.firstName.length * 9 : 0) + 40) + "px"
    },
    attrs: {
      placeholder: _vm.$t("contact.name")
    },
    nativeOn: {
      keyup: function ($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleFilter.apply(null, arguments);
      }
    },
    model: {
      value: _vm.listQuery.firstName,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "firstName", $$v);
      },
      expression: "listQuery.firstName"
    }
  }), _c("el-input", {
    staticClass: "filter-item",
    style: {
      width: Math.max(160, (_vm.listQuery.mobileNumber ? _vm.listQuery.mobileNumber.length * 9 : 0) + 40) + "px"
    },
    attrs: {
      placeholder: _vm.$t("contact.mobile")
    },
    nativeOn: {
      keyup: function ($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleFilter.apply(null, arguments);
      }
    },
    model: {
      value: _vm.listQuery.mobileNumber,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "mobileNumber", $$v);
      },
      expression: "listQuery.mobileNumber"
    }
  }), _c("el-input", {
    staticClass: "filter-item",
    style: {
      width: Math.max(160, (_vm.listQuery.emailAddress ? _vm.listQuery.emailAddress.length * 9 : 0) + 40) + "px"
    },
    attrs: {
      placeholder: _vm.$t("contact.email")
    },
    nativeOn: {
      keyup: function ($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleFilter.apply(null, arguments);
      }
    },
    model: {
      value: _vm.listQuery.emailAddress,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "emailAddress", $$v);
      },
      expression: "listQuery.emailAddress"
    }
  }), _c("div", {
    staticClass: "filter-item date-picker-wrap"
  }, [_c("VueCtkDateTimePicker", {
    staticStyle: {
      width: "220px"
    },
    attrs: {
      range: true,
      right: true,
      color: _vm.$primaryColor,
      formatted: "DD-MM-YYYY",
      "no-label": ""
    },
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  })], 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      placeholder: _vm.$t("contact.enabled"),
      clearable: ""
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "enabled", $$v);
      },
      expression: "listQuery.enabled"
    }
  }, _vm._l(_vm.enableTypeOptions, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.value,
        value: item.key
      }
    });
  }), 1), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "info",
      size: "small",
      icon: "el-icon-search"
    },
    on: {
      click: _vm.handleFilter
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("table.search")) + " ")])], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    key: _vm.tableKey,
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      border: "",
      fit: "",
      "highlight-current-row": ""
    }
  }, [_c("el-table-column", {
    attrs: {
      width: "50",
      align: "center",
      label: "ID",
      prop: "id"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "200",
      label: "Name",
      prop: "fullName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-button", {
          attrs: {
            type: "text",
            size: "mini"
          },
          on: {
            click: function ($event) {
              return _vm.showSecurityDialog(scope.row.id, "clientName");
            }
          }
        }, [_c("i", {
          staticClass: "el-icon-office-building"
        }), _vm._v(" " + _vm._s(scope.row.client.name) + " ")]), _c("br"), _c("el-button", {
          attrs: {
            type: "text",
            size: "mini"
          },
          on: {
            click: function ($event) {
              return _vm.showSecurityDialog(scope.row.id, "fullName");
            }
          }
        }, [_c("i", {
          staticClass: "el-icon-user"
        }), _vm._v(" " + _vm._s(scope.row.firstName + " " + (scope.row.lastName || "")) + " ")]), _c("enabled", {
          model: {
            value: scope.row.enabled,
            callback: function ($$v) {
              _vm.$set(scope.row, "enabled", $$v);
            },
            expression: "scope.row.enabled"
          }
        }), _c("br"), scope.row.designation ? _c("span", [_c("i", {
          staticClass: "el-icon-suitcase"
        }), _c("i", [_vm._v(" " + _vm._s(scope.row.designation) + " ")])]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "240",
      label: "Contact Info",
      prop: "fullName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-button", {
          attrs: {
            type: "text",
            size: "mini"
          },
          on: {
            click: function ($event) {
              return _vm.showSecurityDialog(scope.row.id, "mobileNumber");
            }
          }
        }, [_c("i", {
          staticClass: "el-icon-mobile-phone"
        }), _vm._v(" " + _vm._s(scope.row.mobileNumber) + " ")]), _c("br"), _c("el-button", {
          attrs: {
            type: "text",
            size: "mini"
          },
          on: {
            click: function ($event) {
              return _vm.showSecurityDialog(scope.row.id, "emailAddress");
            }
          }
        }, [_c("i", {
          staticClass: "el-icon-message"
        }), _vm._v(" " + _vm._s(scope.row.emailAddress) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "160",
      label: "Misc",
      prop: "therapy"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.brand ? _c("span", [_vm._v(" Brand: " + _vm._s(scope.row.brand) + " ")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "160",
      label: "Communication Preference",
      prop: "communicationPreference",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.communicationPreference ? _c("el-tag", {
          attrs: {
            type: "info",
            size: "mini",
            effect: "dark"
          }
        }, [_vm._v(" " + _vm._s(scope.row.communicationPreference) + " ")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      align: "center",
      label: "Actions",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/clients-contacts/edit/" + scope.row.id
          }
        }, [_c("el-button", {
          attrs: {
            type: "warning",
            size: "mini",
            icon: "el-icon-edit"
          }
        })], 1)];
      }
    }])
  })], 1), _c("el-dialog", {
    attrs: {
      title: "Security Question",
      visible: _vm.securityDialogVisible,
      width: _vm.isMobile ? "90%" : "40%",
      center: ""
    },
    on: {
      "update:visible": function ($event) {
        _vm.securityDialogVisible = $event;
      }
    }
  }, [_c("el-input", {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      name: "securityquestion",
      disabled: ""
    },
    model: {
      value: _vm.securityQuestion,
      callback: function ($$v) {
        _vm.securityQuestion = $$v;
      },
      expression: "securityQuestion"
    }
  }), _c("el-input", {
    attrs: {
      placeholder: "Security Answer",
      name: "securityAnswer"
    },
    model: {
      value: _vm.securityAnswer,
      callback: function ($$v) {
        _vm.securityAnswer = $$v;
      },
      expression: "securityAnswer"
    }
  }), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.verifySecurityAnswer
    }
  }, [_vm._v(" Submit ")]), _c("el-button", {
    attrs: {
      type: "danger"
    },
    on: {
      click: function ($event) {
        _vm.securityDialogVisible = false;
      }
    }
  }, [_vm._v(" Cancel ")])], 1)], 1), _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getList
    }
  })], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;